import { useEffect, useState } from "react";
import { generateIncrementalName } from "@/utils/runner-names";
import { useListRunners } from "@/queries/runner-queries";
import { type RunnerProvider } from "gitpod-next-api/gitpod/v1/runner_configuration_pb";

type UseRunnerNameOptions = {
    baseName: string;
    provider: RunnerProvider;
};

type UseRunnerNameResult = {
    name: string;
    isLoading: boolean;
    setName: (name: string) => void;
};

export function useRunnerName({ baseName, provider }: UseRunnerNameOptions): UseRunnerNameResult {
    const [name, setName] = useState<string>("");
    const [isInferred, setIsInferred] = useState(true);

    const { data: runners, isLoading, isPending } = useListRunners({ provider });

    // Generate name when runners are loaded or when baseNameGenerator changes
    useEffect(() => {
        if (isLoading || isPending || !isInferred) {
            return;
        }

        const newName = generateIncrementalName(baseName, runners || []);
        setName(newName);
    }, [runners, isLoading, isPending, baseName, isInferred]);

    const updateName = (newName: string) => {
        setName(newName);
        setIsInferred(false);
    };

    return {
        name,
        isLoading: isLoading || isPending,
        setName: updateName,
    };
}
